import { Weapon, type WeaponConfig } from './Weapon';

const ASSAULT_RIFLE_CONFIG: WeaponConfig = {
  id: 'assault_rifle',
  // economy W12, calibrated to budget=30+10L
  price: 1500,
  fireRateMs: 120,
  bulletsPerShot: 1,
  spreadDeg: 5,
  soundKey: 'pistol_shot',
  soundVolume: 0.35,
  shakeShoot: {
    intensity: 0.003,
    duration: 50,
  },
  magazineSize: 30,
  reloadTimeMs: 1800,
  bulletWidth: 5,
  bulletHeight: 3,
  fireMode: 'auto',
  recoilForce: 1.5,
};

export function createAssaultRifle(): Weapon {
  return new Weapon(ASSAULT_RIFLE_CONFIG);
}
